// The demo lead reaches both ChiliPiper (from the UI) and the HQ lead webhook
// (from the API), which must describe the same person identically.
export function splitLeadName(
  name: string,
  email: string
): { firstName: string; lastName: string } {
  const fullName = name.trim();
  const spaceIndex = fullName.indexOf(" ");
  const firstName =
    spaceIndex === -1 ? fullName : fullName.slice(0, spaceIndex);
  // A nameless user still creates a CRM lead, so fall back to the email local
  // part rather than a greeting word like "there" that lands as a first name.
  return {
    firstName: firstName || email.split("@")[0] || "",
    lastName: spaceIndex === -1 ? "" : fullName.slice(spaceIndex + 1),
  };
}
